import get from 'lodash/get';
import { IsNotEmpty, IsOptional, IsString } from 'class-validator';

export enum MessageType {
  RECORDING = 'RECORDING',
  TEXT = 'TEXT',
}

class Message {
  @IsString()
  type: MessageType;
}

export class MessageText extends Message {
  @IsString()
  @IsNotEmpty({ message: 'Enter a message' })
  message: string;

  @IsOptional()
  voice: string;

  @IsOptional()
  language: string;
}

export class MessageRecording extends Message {
  @IsString()
  @IsNotEmpty({ message: 'Select a recording' })
  message: string;
}

export function getMessageTypeClass(typeHelper) {
  const messageType = get(typeHelper, 'object.message.type');
  return messageType === MessageType.TEXT ? MessageText : MessageRecording;
}
